import { render } from "./MailRegister.vue?vue&type=template&id=460c8463&scoped=true"
import script from "./MailRegister.vue?vue&type=script&lang=js"
export * from "./MailRegister.vue?vue&type=script&lang=js"

import "./MailRegister.vue?vue&type=style&index=0&id=460c8463&lang=scss&scoped=true"
import "./MailRegister.vue?vue&type=style&index=1&id=460c8463&lang=scss"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c8463"]])

export default __exports__